export function clamp(number, min, max) {
  return Math.min(Math.max(min, number), max)
}



// WEBPACK FOOTER //
// ./packages/utils/math-extension.js